import {
  getAllEsta,
  setEsta,
  getEstaByid,
  getDevices,
  getUnassociatedEsta,
  importEstablishmentList, 
  reportTroubles,
  getServices,
  getMappedServices,
  getMappedLieux,
  setMappingService,
  setMappingLieu,
  SetConnector,
  GetConnector,
  getDomains as getDomainsApi,
  setDomain as setDomainApi,
  getActivitesFromDomain as getActivitesFromDomainApi,
  moveActivitiesToDomain as moveActivitiesToDomainApi,
  createTemplate as createTemplateApi,
  getTemplatesDomain as getTemplatesDomainApi,
  applyTemplate as applyTemplateApi,
  isExtraFeaturesActive as isExtraFeaturesActiveApi,
  applyExtraFeatures as applyExtraFeaturesApi,
  getAnonymisations as getAnonymisationsApi,
} from '../api/establishment';

import { 
  getConfNetSoins,
  getCongNetsoinsPush,
  setDataNetsoinsFromConf,
  setDataNetsoinsPushFromConf
} from '../misc/urlnetsoins'

import {
  getConfTitan,
  setDataTitanFromConf,
} from '../misc/urltitan'

import modelSync from '../misc/model_sync.json'
import modelPush from '../misc/model_push.json'
import modelTitan from '../misc/model_titan.json'
// eslint-disable-next-line import/prefer-default-export
export async function setEstablishment(data) {
  const estaSeted = await setEsta(data);
  return estaSeted;
}



export async function getAllEstablishment(params, forOptions) {
  if (!params) params = {};
  const allEsta = await getAllEsta(params);

  if (forOptions) {
    return allEsta.map(e => { return { value: e.esta_id, text: `${e.esta_name} (${e.esta_id})` } });
  }
  return allEsta;
}

export async function getEstablishmentById(estaId) {
  const esta = await getEstaByid(estaId);
  return esta;
}

export async function getEstablishmentsWithNoContract(){
  const estas = await getUnassociatedEsta();
  if (estas)  return estas.map(e => { return { value: e.esta_id, text: e.esta_name } });
  return null;
}

export async function getDevicesForEstablishment(estaId) {
  return getDevices(estaId);
}

export async function importEstablishements(cont_id, listArray){
  return importEstablishmentList(cont_id, listArray);
}

export async function reportTroublesShoot(params){
  return reportTroubles(params);
}

export async function getServiceForEstablishments(estaId, forOptions){

  const allServices = await getServices(estaId);
  if (forOptions) {
    if (allServices)
      return allServices.map(s => { return { value: s.serv_id, text: s.serv_name, disabled: !s.serv_is_enable, default: s.serv_is_default } });
  }
  return allServices
}

export async function MappedServices(estaId, cntId) {
  const services = await getMappedServices(estaId, cntId)
  
  if (services) 
    return services.map(s=> {
      s.saved = (s.ext_uri !== null); 
      return s;
    }
      )
}

export async function MappedLieux(estaId, cntId) {
  const lieux = await getMappedLieux(estaId, cntId)
  
  if (lieux) 
    return lieux.map(l=> {
      l.saved = (l.ext_uri !== null); 
      return l;
    }
  )
}



export async function SetServiceUri(estaId, cntId, servId, uri){

  const data = await setMappingService({esta_id: estaId, cnt_id: cntId, serv_id: servId, ext_uri: uri });

  return (data && data?.seec_id > 0);
}

export async function SetLieuUri(estaId, cntId, anpId, uri){
  const data = await setMappingLieu({esta_id: estaId, cnt_id: cntId, anp_id: anpId, ext_uri: uri });

  return (data && data?.anec_id > 0);
}

export async function SetConnectorData(estaId, cnx, conf){
  let value = null;
  if (cnx.name === 'NETSOINS')
    value = setDataNetsoinsFromConf(conf, cnx.model);
  if (cnx.name === 'NETSOINS_PUSH')
    value = setDataNetsoinsPushFromConf(conf, cnx.model);
  if (cnx.name === 'TITAN') {
    value = setDataTitanFromConf(conf, cnx.model);
  }
  const data = await SetConnector({esta_id: estaId, cnt_id: cnx.id, eec_data: value, eec_is_enable: (['NETSOINS', 'TITAN'].indexOf(cnx.name) !== -1) ? conf.enable: conf.enablepush});
  return {good: data && data?.eec_id > 0, eec_id: data.eec_id};
}


export async function GetConnectorData(estaId, cnxs){
  const data = await GetConnector({esta_id: estaId});
  let conf = {};
  cnxs.forEach( (cnx) => {
    const connector = data?.find(c=> c.eec_cnt_id === cnx.id);
    if (cnx.name === 'NETSOINS') conf = getConfNetSoins(conf, connector, cnx.model || modelSync); 
    if (cnx.name === 'TITAN') conf = getConfTitan(conf, connector, cnx.model || modelTitan);
    if (cnx.name === 'NETSOINS_PUSH') conf = getCongNetsoinsPush(conf, connector, cnx.model || modelPush);
  })
  return conf;

}

export async function getDomains(estaId) {
  const domains = await getDomainsApi(estaId);
  return domains.map((d) => ({...d, loading: false}))
}

export async function setDomain(estaid, dacid, label, color, enable) {
  return setDomainApi(estaid, dacid, label, color, enable);
}

export async function getActivitesFromDomain(estaid, dacid) {
  return getActivitesFromDomainApi(estaid, dacid)
}

export async function moveActivitiesToDomain(estaid, activities) {
  return moveActivitiesToDomainApi(estaid, activities)
}

export async function createTemplate(name, domains) {
  return createTemplateApi(name, domains)
}

export async function getTemplatesDomain() {
  return getTemplatesDomainApi()
}

export async function applyTemplate(estaid, templateid, replace=false) {
  return applyTemplateApi(estaid, templateid, replace)
}

export async function isExtraFeaturesActive(estaid) {
  const data = await isExtraFeaturesActiveApi(estaid)
  const keys = Object.keys(data)
  const list = []
  keys.forEach(k => {
    const name = k.split('_')
    name.shift()
    list.push({name: k, enable: data[k], common_name: name.join('_')})
  })
  return list
}

export async function applyExtraFeatures(estaid, features) {
  return applyExtraFeaturesApi(estaid, features)
}

export async function getAnonymisations(estaid) {
  return getAnonymisationsApi(estaid);
}